// ContactForm.js
import React, { useState } from "react";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaFacebookF,
} from "react-icons/fa";
import "../styles/contactform.css";
import Snackbar from "./snackbar"; // Import the Snackbar component
import { useTranslation, Trans } from "react-i18next"; // Import useTranslation and Trans

function ContactForm() {
  const { t } = useTranslation(); // Initialize the t function

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "info",
    position: "bottom-center",
    duration: 4000,
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const showSnackbar = (
    message,
    type = "info",
    position = "bottom-center",
    duration = 4000
  ) => {
    setSnackbar({ open: true, message, type, position, duration });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        "https://ddmwrl2uut5q8.cloudfront.net/submit-contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (res.ok) {
        showSnackbar(t("contactForm.snackbar.success"), "success", "top-right");
        setFormData({
          name: "",
          company: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        const errorData = await res
          .json()
          .catch(() => ({ message: t("contactForm.snackbar.defaultErrorServer") })); // Fallback if .json() fails
        showSnackbar(
          t("contactForm.snackbar.errorGeneric", {
            errorMessage: errorData.message || t("contactForm.snackbar.defaultError"),
          }),
          "error",
          "bottom-center",
          6000
        );
      }
    } catch (err) {
      console.error("Network error:", err);
      showSnackbar(
        t("contactForm.snackbar.errorNetwork"),
        "error",
        "bottom-center",
        6000
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="contact-form-section" id="contact">
        <div className="container contact-wrapper">
          <div className="contact-info">
            <h2>
              {/*
                Using Trans component with the 'components' prop.
                The <0></0> in your JSON ("Ready to Build? <0></0> Let’s Connect.")
                will be replaced by the first element in the 'components' array, which is <br />.
              */}
              <Trans i18nKey="contactForm.title" components={[<br />]} />
            </h2>
            <p>{t("contactForm.description")}</p>

            <ul className="contact-details">
              <li>
                <FaEnvelope /> {t("contactForm.details.email")}
              </li>
              <li>
                <FaPhone /> {t("contactForm.details.phone")}
              </li>
              <li>
                <FaMapMarkerAlt /> {t("contactForm.details.address")}
              </li>
            </ul>

            <div className="social-links">
              <a href="#" aria-label={t("contactForm.social.linkedin")}>
                <FaLinkedinIn />
              </a>
              <a href="#" aria-label={t("contactForm.social.facebook")}>
                <FaFacebookF />
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <input
                type="text"
                name="name"
                placeholder={t("contactForm.form.namePlaceholder")}
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder={t("contactForm.form.companyPlaceholder")}
                value={formData.company}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder={t("contactForm.form.emailPlaceholder")}
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone"
                placeholder={t("contactForm.form.phonePlaceholder")}
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <textarea
              name="message"
              placeholder={t("contactForm.form.messagePlaceholder")}
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" disabled={loading}>
              {loading
                ? t("contactForm.form.sendingButton")
                : t("contactForm.form.submitButton")}
            </button>
          </form>
        </div>
      </section>
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        type={snackbar.type}
        position={snackbar.position}
        duration={snackbar.duration}
        onClose={handleCloseSnackbar}
      />
    </>
  );
}

export default ContactForm;